import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Modal, Card } from "antd";
import { Link, useHistory } from "react-router-dom";
import logoSmall from "../../assets/images/logo/logo.svg";
import { UserLogin } from "../../redux/Login/LoginActions";
import { useDispatch } from "react-redux";
import * as actions from "../../redux/Login/LoginTypes";
import { RiLoginCircleLine } from "react-icons/ri";
import { notificationEmail, resetPasswordMail } from "../../redux/Notification/NotificationActions";
import { UiConsts } from "../../appconst";

export default function Login() {
  const [spinStatus, setSpinStatus] = useState(false);
  const [remember, setRemember] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const savedPassword = localStorage.getItem("password");
    const savedRemember = localStorage.getItem("rememberMe") === "true";

    if (savedPassword && savedRemember) {
      formRef.current?.setFieldsValue({ password: savedPassword });
      setRemember(true);
    }
  }, []);

  const handleLogin = async () => {
    try {
      const fieldvalues = await formRef.current.validateFields();
      const payload = {
        userName: fieldvalues?.userName,
        password: fieldvalues?.password,
      };

      dispatch({ type: actions.LOGIN, payload });

      setSpinStatus(true);
      const result = await UserLogin(payload);
      setSpinStatus(false);

      if (result?.success) {
        history.push("/dashboard");
      } else {
        Modal.error({ content: result?.msg?.error });
      }
    } catch (error) {
      setSpinStatus(false);
    }
  };

  const handleResetPassword = async () => {
    try {
      const fieldvalues = await formRef.current.validateFields();
      const toEmail = fieldvalues?.mailid;
      localStorage.setItem("mailid", toEmail);

      const resetUrl = `${UiConsts.UiBaseUrl}/resetpassword?tomail=${toEmail}&token={{token}}`;
      const payload = {
        ToEmail: toEmail,
        Subject: "Password Reset Request",
        Body: `
            <div style="background-color:#f4fdff;padding:24px;border-radius:10px;font-family:'Segoe UI',sans-serif;max-width:600px;margin:auto;">
              <h4 style="color:#ad2042;">Reset your password</h4>
                <p>Hi User,</p>
                <p>Welcome!</p>
                <p>You are receiving this email because you have registered on our site.</p>
                <a href="${resetUrl}" style="display:inline-block;padding:12px 18px;background-color:#ad2042;color:#fff;text-decoration:none;border-radius:6px;font-weight:bold;margin-top:16px;">
                  Reset Password
                </a>
            </div>`,
      };

      const result  = await resetPasswordMail(payload)
      // await notificationEmail(payload);
      if(result.Success){
        Modal.success({
        content: result.Message,
      });
      } else {
        Modal.error({
        content: "User doesn't exist",
      });
      }
      

      setIsForgotPassword(false);
    } catch (err) {
      Modal.error({
        content: "Please enter a valid email address.",
      });
    }
  };

  return (
    <Row
      gutter={[0, 0]}
      align="middle"
      justify="center"
      className="hp-authentication-page"
    >
      <Col
        span={24}
        sm={20}
        md={16}
        lg={12}
        xl={8}
        xxl={6}
        className="hp-py-sm-0 hp-py-md-64"
      >
        <Card className="hp-authentication-card">
          <div className="hp-d-block hp-w-100 hp-text-center hp-mb-12">
            <img src={logoSmall} alt="Logo" width="130" />
          </div>
          <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-0 hp-text-center">
            Very good works are waiting for you 🤞
          </p>
          <Form
            ref={formRef}
            layout="vertical"
            name="basic"
            initialValues={{ remember: true }}
            className="hp-mt-sm-16 hp-mt-32"
          >
            {isForgotPassword ? (
              <>
                <Form.Item
                  name="mailid"
                  label="Mail ID :"
                  className="hp-mb-16"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    { type: "email", message: "Please enter a valid email!" },
                  ]}
                >
                  <Input placeholder="Enter Mail Address" />
                </Form.Item>
                <Button
                  htmlType="submit"
                  block
                  type="primary"
                  onClick={handleResetPassword}
                >
                  Reset Password
                </Button>
              </>
            ) : (
              <>
                <Form.Item
                  name="userName"
                  label="Username :"
                  className="hp-mb-16"
                  rules={[
                    { required: true, message: "Please enter your username!" },
                  ]}
                >
                  <Input placeholder="Enter Username" />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password :"
                  className="hp-mb-16"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                  ]}
                >
                  <Input.Password placeholder="Enter Password" />
                </Form.Item>
                <Row gutter={32} className="hp-float-right">
                  <Col>
                    <Form.Item>
                      <Link
                        to="#"
                        onClick={() => setIsForgotPassword(true)}
                        className="hp-text-color-black-0 hp-badge-text"
                      >
                        Forgot Password?
                      </Link>
                    </Form.Item>
                  </Col>
                </Row>
                <div className="hp-d-block hp-w-100 hp-text-center">
                  <Button
                    type="primary"
                    block
                    loading={spinStatus}
                    className="hp-py-8 hp-text-uppercase"
                    htmlType="submit"
                    onClick={handleLogin}
                  >
                    <RiLoginCircleLine size={18} className="hp-mr-8" /> Login
                  </Button>
                </div>
              </>
            )}
          </Form>
        </Card>
      </Col>
    </Row>
  );
}
